(function() {
    if (typeof(window.matchMedia) != 'undefined') {
        var mobileJS = window.matchMedia('all and (max-width: 780px)').matches,
            phoneJS = window.matchMedia('all and (max-width: 480px)').matches;
    } else {
        var mobileJS = false, phoneJS = false;
    }

    FG.Package = {
        
        carted : false,
        analyticsFired : false,
        
        setCarted : function(carted) {
            this.carted = carted;
        },
        
        getCarted : function() {
            return this.carted;
        },
        
        init : function() {
            // Attach 'add to cart' button click to function
            $('#btn-add-cart-package').unbind('click.addcart').bind('click.addcart', function() {
                FG.Package.addToCart();
            });

            var labelName = $('#labelName').val(),
                packageTitle = $('#txt-event-name').val(),
                packageKey = $('#txt-event-key').val();

            // resets the entire page when user navigates away from page (press backbutton)
            $(window).unload(function(){
                $('.sel-qty').val(0);
            })

            FG.Package.bindQuantityDropDowns();
            FG.Package.selectItem();
            FG.Package.matchQuantity();
            FG.Package.showGroups();
            FG.Package.setPreConfiguredQuantity();
            FG.Package.isEventSoldOut();
            FG.Package.callBestAvailOrPYO();
    
        },

        isEventSoldOut : function() {
        //change package event card text from "select" to "unavailable"    
            $('.PackageEvent').each(function() {
                if ($(this).data('amountavailable') == 0) {
                    $(this).addClass('soldOut');
                    $(this).find('.select-button').text('Unavailable').css('background-color', 'grey').css('color', 'black')
                    $(this).unbind('click');
                }
            })

        //if quantity dropdown only has the option "0", change drop down option to "unavailable"  
            if ($('.group0 option:last-child').val() == "0") {
                $('.group0 .sel-qty').empty();
                $('.group0.sel-qty').append('<option>Unavailable</option>')
            };

            if ($('.group1 option:last-child').val() == "0") {
                $('.group1 .sel-qty').empty();
                $('.group1 .sel-qty').append('<option>Unavailable</option>')
            };
        },

        // called when 1st selection group's dropdown is changed
        // 2nd selection group's dropdown options can be less than/equal to 1st selection group's chosen dropdown #
        matchQuantity : function() {

            $('.group0 .sel-qty').unbind('change.match').bind('change.match', function() {
                var group0Num = $('.group0 .sel-qty').val();
                var group1Max = $('.group1.selected').data('amountavailable');

                $('.matchQuantity.sel-qty').empty();

                if (group0Num < group1Max) {
                    for (i = 0; i <= group0Num; i++) {
                        $('.matchQuantity.sel-qty').append('<option value="' + i + '">' + i + '</option>');
                    }
                } else if (group0Num > group1Max) {
                    if (group1Max) {
                        for (i = 0; i <= group1Max; i++) {
                            $('.matchQuantity.sel-qty').append('<option value="' + i + '">' + i + '</option>');
                        }
                    } else {
                        $('.group1 .sel-qty').append('<option>Unavailable</option>')
                    }
                } else {
                    for (i = 0; i <= group1Max; i++) {
                        $('.matchQuantity.sel-qty').append('<option value="' + i + '">' + i + '</option>');
                    }
                }

            })
        },

        // called every time a package card is selected 
        // compare all selected event cards in a selection group, the lowest 'data-amountavailable' becomes that selection group dropdown's max option
        changeQuantityBySelected : function(group) {
            var firstItem = $(group + '.selected')[0]
            var lowestAvailable = $(firstItem).data('amountavailable');
            var qtyDrop = $(firstItem).data('qtydrop');
            if (qtyDrop === null){
                return 0;  // that means nothing is selected so skip the rest
            }

            $(group + '.sel-qty').empty();
            var qtystr = String(qtyDrop); 
            var a = qtystr.split(',');
            a.unshift("0"); // need drop down to start with 0

            var i;
            for (i = 0; i < a.length; ++i) {
                $(group + '.sel-qty').append('<option value="' + a[i] + '">' + a[i] + '</option>');
            }
        },

        // called every time a package card is selected if "quantity matching" is enforced
        // compare all selected event cards in a selection group
        // set selection group dropdown options to either 1st group's dropdown # OR 2nd group's lowest 'data-amountavailable', whichever is lower
        changeQuantityByMatchQuantity: function(group) {
            var firstItem = $(group + '.selected.matchQuantity')[0]
            var lowestAvailable = $(firstItem).data('amountavailable');

            $(group + '.selected.matchQuantity').each(function(){
               if ($(this).data('amountavailable') < lowestAvailable){
                    lowestAvailable = $(this).data('amountavailable');
               }
            })

            if ( lowestAvailable < $('.group0.sel-qty').val()) {
                FG.Package.changeQuantityBySelected(group);
            } else if (lowestAvailable > $('.group0.sel-qty').val()) {
                $(group + '.sel-qty').empty();
                for (i = 0; i <= $('.group0.sel-qty').val(); i++) {
                    $(group + '.sel-qty').append('<option value="' + i + '">' + i + '</option>');
                }
            }
        },

        // set preconfig package dropdown option max to equal the lowest 'data-amountavailable' of all events
        // if lowest 'data-amountavailable' equals 0, change "add to cart" button to say "unavailable"
        setPreConfiguredQuantity: function() {
            if ($('.preconfigured .packageQuantity .sel-qty').length >= 1) {
                $('.preconfigured .packageQuantity .sel-qty').empty();
                var preconfiguredQuantity = 1000;
                for (i = 0; i < $('.group0.selected').length; i++) {
                    var this_item = $('.group0.selected')[i];
                    if ($(this_item).data('amountavailable') < preconfiguredQuantity) {
                        preconfiguredQuantity = $(this_item).data('amountavailable');
                    }
                }
                for (i = 0; i <= preconfiguredQuantity; i++) {
                    $('.group0.sel-qty').append('<option value="' + i + '">' + i + '</option>');
                }

                for (i = 0; i < $('.group1.selected').length; i++) {
                    var this_item = $('.group1.selected')[i];
                    if ($(this_item).data('amountavailable') < preconfiguredQuantity) {
                        preconfiguredQuantity = $(this_item).data('amountavailable');
                    }
                }
                for (i = 0; i <= preconfiguredQuantity; i++) {
                    $('.group1.sel-qty').append('<option value="' + i + '">' + i + '</option>');
                }

                if (preconfiguredQuantity == 0) {
                    $('#btn-add-cart-package').text('Unavailable');
                    $('#btn-add-cart-package').attr('disabled', true);
                }
            }

        },

        showGroups : function() {
            //hide each selection group's quantity drop down if no event is selected 
            var packages = $('.packageReserveInfo').length
            for (var i = 0; i < packages; i++) {
                if ($('.group'+i+'.selected').length==0){
                    $('.group'+i+'.packageQuantity').hide();
                }
            }
	   
	    var hasGroup2 = ($('#txt-group-length').val() > 2) ? true : false;
	    var hasGroup3 = ($('#txt-group-length').val() > 3) ? true : false;
	     
	    if ($('#txt-group-length').val() > 1){
                var g1Btn = '<button id="group0-btn" class="qty-btn fbtn">Select</button>';
                $('.group0.packageQuantity').append(g1Btn);
	    }

            $('.group0.package-items').unbind('click.showGroups').bind('click.showGroups', function() { 
                $('#btn-add-cart-package').hide();
                $('.group1').hide();
                $('.group2').hide();
                $('.group1.sel-qty').val(0);

                FG.Package.selectItem('.group0', this);
                if ($('.group0.selected:visible').length == 0) {
                    $('.group0.packageQuantity').hide();
                    $('.group0.itemCount').show();
                } else if ($('.group0.selected:visible').length < $('.group0.packageQuantity .sel-qty').data('mincount')) {
                    $('.group0.packageQuantity').hide();
                    $('.group0.itemCount').show();
                } else {
                    $('.group0.packageQuantity').show();
                    $('.group0.itemCount').hide();
		    if($('#txt-group-length').val() > 1) $('#btn-add-cart-package').show();
                }
            });

            function showGroup1() {
                // hide selection group 2
                if ($('.group0 .sel-qty').val() == 0){
                    $('.group1').hide();
                }
		var eventType = 'submit.showGroup1';
		var submitBtn = '<button id="group1-btn" class="qty-btn fbtn">Select</button>';
		var evTarget = '#group0-qty-form';
		if(hasGroup2) $('.group1.packageQuantity').append(submitBtn);
		var eventType2 = (hasGroup2) ? 'submit.resetGroup1' : 'change.resetGroup1';
		var evTarget2 = (hasGroup2) ? '#group1-qty-form' : '.group1 .sel-qty';
                // Changing quantity of group0 dropdown resets/shows group1
		$(evTarget).unbind(eventType).bind(eventType, function() {
                    //reset every group's attributes on quantity change
                    $('.selected').removeAttr('data-sectionselect').removeAttr('data-priceselect').removeAttr('data-tickettypes').removeAttr('data-seatids').removeAttr('data-seatcount');
                    $('.group1.sel-qty').val(0).change();
                    
                    //if group1 has package cards (2+ event options), unselect the events
                    if ($('.group1.single-item').length == 0){
                        $('.group1.selected .select-button').text('Select');
                        $('.group1.package-items.selected').removeClass('selected');
                        $('.group1.package-items').removeClass('unselected');
                    }
                    
                    if ($('.group0 .sel-qty').val() > 0 && !$('.group0.PackageEvent.selected').hasClass('bestavail')) {
                        if ($('.group1.single-item').length){
                            $('.group1.packageQuantity').show();
                        } else {
                             $('.group1.packageQuantity').hide();
                        }
                        $('.group1').not('.packageQuantity').show();
                        if(!hasGroup2) $('#btn-add-cart-package').show();
                        $('html, body').animate({
                            scrollTop: $('#group1').offset().top
                        }, 1000);
                    } else {
                        $('#btn-add-cart-package').hide();
                        $('.group1').hide();
                    }

                });

                //reset group1 attributes on quantity change 
                $(evTarget2).unbind(eventType2).bind(eventType2, function() {
                    $('.group1.selected').removeAttr('data-sectionselect').removeAttr('data-priceselect').removeAttr('data-tickettypes').removeAttr('data-seatids').removeAttr('data-seatcount');
                });

                $('.group1.package-items').unbind('click').bind('click', function() {
                    FG.Package.selectItem('.group1', this);
                    $('#btn-add-cart-package').hide();

                    // Same logic as showGroups (group0)
                    if ($('.group1.selected:visible').length == 0) {
                        $('#btn-add-cart-package').show();
                        $('.packageQuantity.group1').hide();
                        $('.packageQuantity.group1 .sel-qty').val(0).change();
                        $('.itemCount.group1').show();
                        $('.group2').hide();
                    } else if ($('.group1.selected:visible').length < parseInt($('.group1.packageQuantity .sel-qty').data('mincount'))) {
                        $('.group1.itemCount').show();
                        $('.packageQuantity.group1').hide();
                        $('.group2').hide();
                        $('.group1.sel-qty').val(0).change();
                    } else {
                        $('.packageQuantity.group1').show();
                        $('.group1.itemCount').hide();
                    }
                });
            }

            function showGroup2() {
                showGroup1();
                $('.group2').hide();
		var eventType = 'submit';
		var submitBtn = '<button id="group2-btn" class="qty-btn btn btn-primary"></button>';
                if(hasGroup3) $('.group2.packageQuantity').append(submitBtn);
		var evTarget = '#group1-qty-form'; 
		$(evTarget).on(eventType, function() {
                    if (($('.group1 .sel-qty').val() > 0) && ($('.group0 .sel-qty').val() > 0)) {
                        $('.group2').show();
                        if(!hasGroup3) $('#btn-add-cart-package').show();
                    } else {
                        $('.group2').hide();
                    }
                });
                $('.group2.package-items').unbind('click').bind('click', function() {
                    FG.Package.selectItem('.group2', this);
                });
            }

            // Initialize showGroupX function based on how many groups there on, noted in the hidden field
            if ($('#txt-group-length').val() > 2) {
                showGroup2();
            } else if ($('#txt-group-length').val() == 2) {
                showGroup1();
            } else {
                $('#btn-add-cart-package').show();
            }
        },

        selectItem : function(group, self) {
            var Count = $(group + '#count').data('mincount'),
                MaxCount = $(group + '.packageQuantity .sel-qty').data('maxcount');

            for (var i = 0; i < $(group + '.selected').length; i++) {
                Count--;
            }

            // If MaxCount is 0, any # of selections possible
            if (MaxCount == 0) {

                if ($(self).hasClass('selected')) {
                    $(self).removeClass('selected').removeAttr('data-sectionselect').removeAttr('data-priceselect').removeAttr('data-tickettypes').removeAttr('data-seatids').removeAttr('data-seatcount').attr('aria-checked', false);
                    $(self).find('.select-button').text('Select');
                } else {
                    $(self).addClass('selected').attr('aria-checked', true);
                    $('.selected .select-button').text('Selected');
                }
            } else {
                if ($(self).hasClass('selected')) {
                    Count++;
                    $(self).removeClass('selected').removeAttr('data-sectionselect').removeAttr('data-priceselect').removeAttr('data-tickettypes').removeAttr('data-seatids').removeAttr('data-seatcount').attr('aria-checked', false);
                    $(self).find('.select-button').text('Select');
                } else if (MaxCount == 1) {
                    // If MaxCount = 1, clicking new item will also unselect previously selected item.
                    $(group + '.selected').removeClass('selected').removeAttr('data-sectionselect').removeAttr('data-priceselect').removeAttr('data-tickettypes').removeAttr('data-seatids').removeAttr('data-seatcount').attr('aria-checked', false);
                    $(group + '.package-items').not('.soldOut').find('.select-button').text('Select');
                    $(self).addClass('selected').attr('aria-checked', true);
                    $('.selected .select-button').text('Selected');
                } else if ($(group + '.selected').length < MaxCount) {
                    Count--;
                    $(self).addClass('selected').attr('aria-checked', true);
                    $('.selected .select-button').text('Selected');
                }
            }

            FG.Package.changeQuantityBySelected(group);
            FG.Package.changeQuantityByMatchQuantity(group);

            // if atleast 1 card is selected, gray out other cards (css class 'unselected'), if none are selected, return to normal opacity 
            if ($(group).hasClass('selected')){
                $(group+'.package-items.selected').removeClass('unselected')
                $(group+'.package-items').not('.selected').addClass('unselected')
            } else {
                $(group+'.package-items').removeClass('unselected')
            }
        },

        // determines if selected event is best available or pick your seat
         callBestAvailOrPYO: function() {

            $('.sel-qty').unbind('change.select').bind('change.select',function(){
                var self = $(this);
                if (self.val()>0){
                    //group[n] must be the first class name of each html element
                    var groupNumber = '.'+self.attr('class').split(' ')[0];
                    var bestAvailable = $(groupNumber + '.PackageEvent.selected').hasClass('bestavail');
                    var pickYourOwn = $(groupNumber + '.PackageEvent.selected').hasClass('pickyourown');
                    var packageEvent = $(groupNumber + '.selected');
                    
                    if (bestAvailable && !pickYourOwn) {
                        FG.Package.bindBestAvailable(packageEvent, self);
                    } else if (pickYourOwn) {
                        FG.Package.bindPickYourOwn(packageEvent, self);
                    } 
                }
            });
        },
        //returns boolean based on quantity selected to enable/disable cart button
        checkSelectors: function() {
            var result = {
                formValidated : false,
                addCartMsg: false
            }

            $('.sel-qty').each(function() {
                var val = $(this).val();
                if (parseInt(val) > 0){
                    result.formValidated = true;
                } else if ($(this).data('mincount') > 0) {
                    result.formValidated = false;
                } else if ($(this).data('mincount')===0) {
                    result.formValidated = true;
                    result.addCartMsg = true;
                }
            });

            return result;
        },

        addToCart : function() {
            //GTM
            var cartGTM = {
                'event':'addToCart',
                ecommerce:{
                    add:{
                        products:[]
                    }
                }
            }

            var formValidated = false,
                self = this,
                dataArray = [],
                formValidated = false,
                $addToCart = $('#modal-addcart'),
                Ajax = new FG.Ajax('cart'),
                packageId = $('.sel-qty').data('packageid'),
                $addToCartFooter = $('#modal-addcart-close').parent(),
                quantity = null,
                items = []

            formValidated = FG.Package.checkSelectors().formValidated;

            if (formValidated == true) {
                $('#buy-error').html('').hide();
                $('#btn-add-cart-package').addClass('btn-buy');
                $('#btn-add-cart-package').removeClass('buynotready').removeClass('disabled');
            } else {
                $('#buy-error').html('Please select a quantity').show().removeClass('hide');
                $('#btn-add-cart-package').removeClass('btn-buy');
                $('#btn-add-cart-package').addClass('buynotready').addClass('disabled');
                return false;
            }

            $('.sel-qty').each(function() {
            
                // Set variables
                var quantity = parseInt($(this).val()), 
                    eventHubId = null, 
                    sectionId = null, 
                    ticketTypeId = null, 
                    seatIds = null,
                    groupNumber = '.' + $(this).parent().attr('class').split(' ')[0];

                // Get each selected item into the items array
                if (quantity > 0) {
                    $(groupNumber + '.selected').each(function() {

                        eventHubId = $(this).data('eventhubid');
                        sectionId = $(this).data('sectionid');
                        ticketTypeId = $(this).data('tickettypeid');
                        packagePlanGroupId = $(this).data('packageplangroupid'),
                        price = $(this).data('priceselect'),
                        section = $(this).data('sectionselect');
                        bestAvail = $(this).data('bestavail');
                        seatIds = $(this).data('seatids');

                        //GTM
                        var name = $(this).data('name');
                        var eventId = $(this).data('id');
                        var category = $(this).data('category');
                        var eventPrice = $(this).data('price');
                        var variant = $(this).data('variant');
                        var productGTM = {
                            name: name,
                            id: eventId,
                            brand: "FGT",
                            category: category,
                            variant: variant,
                            quantity: quantity,
                            price: eventPrice
                        }

                        cartGTM.ecommerce.add.products.push(productGTM);
                        
                        if (seatIds) {var seatIdArray = seatIds.toString().split(',');}
                        if ($(this).data('tickettypes')) { var ticketTypes = $(this).data('tickettypes').toString().split(','); }

                        if (seatIds && seatIdArray.length > 1) {
                            for (var i = 0; i < seatIdArray.length; i++) {
                                items.push({
                                    quantity: 1,
                                    packagePlanGroupId : packagePlanGroupId,
                                    eventHubId : eventHubId,
                                    sectionId : sectionId,
                                    ticketTypeId : ticketTypeId,
                                    bestAvail : bestAvail,
                                    seatId: seatIdArray[i]
                                })
                            }
                        } else {
                            items.push({
                                quantity : quantity,
                                packagePlanGroupId : packagePlanGroupId,
                                eventHubId : eventHubId,
                                sectionId : sectionId,
                                ticketTypeId : ticketTypeId,
                                price : price,
                                section : section,
                                bestAvail : bestAvail,
                                ticketTypes : ticketTypes,
                                seatId: seatIds
                            })
                        }
                    })
                }
            });

            // If an actual quality, create dataArray object with all info
            dataArray.push({
                packageId : packageId,
                items : items
            });
            
            // in case of an empty items array
            if (!dataArray[0]['items'] || dataArray[0]['items'].length === 0) {
                return false;
            }


            // in case of an empty items array
            if (!dataArray[0]['items'] || dataArray[0]['items'].length == 0) {
                return false
            }

            // Notify Tradable Bits that user added items to their cart
            FG.tradableBits().savePackageCartData(dataArray);

            // trying to cart
            $('#div-add-cart-message').html('');

            $('#div-btn-add-cart').attr('disabled', 'disabled');

            $addToCartFooter.addClass('hidden');

            $addToCart.modal({
                backdrop : 'static',
                keyboard : false
            }).modal('show');

            Ajax.setMessageDiv('#div-add-cart-message');

            try {

                Ajax.setRequestData({
                    dataArray : dataArray
                });

                Ajax.setSuccessCallback(function(FGResponse){
                    self.processAddCartResponse(FGResponse, cartGTM);
                });

                Ajax.setFailureCallback(function(FGResponse) {

                    $('#div-btn-add-cart').removeAttr('disabled');

                    $addToCartFooter.removeClass('hidden');

                    if (typeof FGResponse != 'undefined') {
                        $('#buy-error').html(FGResponse.msg).hide();

                        // If the session is locked, this means the user tried
                        // to cart something again
                        if (FGResponse.errorType == 'SessionLockedException') {
                            FGResponse.isJob = true;
                            self.processAddCartResponse(FGResponse, cartGTM);
                        }
                    }

                });

                Ajax.send();
                
                this.setCarted(true);

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }
        },

        /**
         * //Bind to the dropdowns for quantity to activate/inactivate the add
         * to cart button and change text from "Add To Cart" to "No thanks..."
         */
        bindQuantityDropDowns : function() {
            $('.sel-qty').removeAttr('disabled');
            $.each($('.sel-qty'),function(idx,el){
            var $this = $(this);
            var totalGroups = $('#txt-group-length').val();
            var groupNum = $.map($this.parent('.packageQuantity').attr('class').split(/\s+/), function(n,i){
                if(n.indexOf('group') > -1) {
                    return parseInt(n.replace('group',''));
                }
            });
            groupNum = groupNum[0];
            var evTarget = (groupNum+1 < totalGroups ) ? $this.parent('[role="form"]') : $this;
            var evType = (groupNum+1 < totalGroups ) ? 'submit.quantitydrop' : 'change.quantitydrop';
        
        evTarget.unbind(evType).bind(evType, function(){
            var selectorCheck = FG.Package.checkSelectors()
                	var hasQuantitySelected = selectorCheck.formValidated;
                	var addCartMsg = selectorCheck.addCartMsg;

                	if (hasQuantitySelected == true) {
                    		$('#buy-error').html('').hide();
                    		$('#btn-add-cart-package').addClass('btn-buy').removeClass('buynotready').removeClass('disabled');

                    		if (addCartMsg) {
                        		$('#btn-add-cart-package').text('No thanks, just add my tickets to my cart')
                    		} else {
                        		$('#btn-add-cart-package').text('Add To Cart')
                    		}

                   		$('#btn-add-cart-package').show();

                	} else {
        	            $('#btn-add-cart-package').removeClass('btn-buy').addClass('buynotready').addClass('disabled');
	                }
		});

	    });
        },

        bindPickYourOwn : function(packageEvent, eventQuantity) {
            var self = this;
            var eventhubkey = packageEvent.data('eventhubkey');
            var packageplanid = packageEvent.data('packageplanid');
            var pickyourownurl = document.location.protocol+"//"+document.location.host+"/event/" + eventhubkey + "/pickyourown?packageId=" + packageplanid;
            var inGroup0 = packageEvent.hasClass('group0');
            var group0qty = $('.group0.sel-qty').val();
            var packagegroupid = packageEvent.data('packageplangroupid');
            var packageGroupElement = $('div.packageReserveInfo[data-packagegroupid="'+ packagegroupid +'"]');
            var packageGroupElementHeight = packageGroupElement.css( "height" );
            var currhtml = packageGroupElement.html();
            var attr = packageEvent.attr('data-seatids');
            var matchQuantity = $('select.matchQuantity[data-packagegroupid="'+ packagegroupid +'"]').length;
            var maxAmount = packageEvent.data('amountavailable');
            var seatCount = packageEvent.data('seatcount');
            var groupNumber = packageEvent.attr('class').split(' ')[0]
            var groupNumberClass = "." + groupNumber
            var pageElements = $('.selectable-package').children().not("#"+groupNumber).not('.extraInfo');
            var seatAltName = packageEvent.data('seataltname') || 'Seat';
            var seatAltNamePlural = seatAltName + 's';

            if (matchQuantity) {
                maxAmount = Math.min(parseInt($('select.group0').val()), maxAmount);
            }

            $.get(pickyourownurl, function(html) {
                $('#btn-add-cart-package').hide();
                eventQuantity.parent().hide();
                packageGroupElement.html(html);

                // Adjust PYO for within packages, removing best available and repositioning everything (moved hide to css)
                $('#pyo-how h4').text('(How it works)');

                $('#pyo-how').parent().prepend('<h3>Pick Your Own ' + seatAltNamePlural + '</h3>');
                $('ol.custom-counter li:nth-child(3)').text('Click the Select ' + seatAltNamePlural + ' button');
                $('#btn-add-cart-seat').text('Select ' + seatAltNamePlural);

                $('#seating-chart').parent().prepend('<h3>Best Available</h3>');
                $('#pick-your-seats-intro #seating-chart').css('border','none');

                var klon = $('#btn-add-cart');
                klon.clone().attr('id', 'btn-package-back' ).insertAfter( klon ).text('Cancel').removeClass('buynotready col-sm-8').addClass('btn-buy col-sm-5 nopadding col-sm-offset-1');

                $('#btn-add-cart').text('Select Options').removeClass('col-sm-8').addClass('col-sm-5 nopadding');
                
p
                $('#quantity').unbind('change.disable').bind('change.disable', function(){
                    if ($('#quantity').val() > 0) { 
                        $('.best-available-options #btn-add-cart').removeClass('buynotready').addClass('btn-buy').attr('disabled', false);
                    } else {
                        $('.best-available-options #btn-add-cart').removeClass('btn-buy').addClass('buynotready').attr('disabled', true);
                    } 
                    
                })

                $('#quantity').val(eventQuantity.val()).change()
                $('#quantity option:gt('+ maxAmount +')').remove();

                //hide everything but PYO/BA after it's loaded
                $(groupNumberClass+'.sub-ribbon').hide();
                $(groupNumberClass+'.selectable-package-info').hide();
                pageElements.hide();

                $('#btn-package-back').unbind('click').bind('click', function(e) {
                    // Reset html back to previous state
                   
                    pageElements.show();
                    $(groupNumberClass+'.sub-ribbon').show();
                    $('.group1.selectable-package-info').show();
                    packageGroupElement.html(currhtml);

                    FG.Package.init();

                    // Deselect everything after cancel
                    if ($(groupNumberClass+'.single-item').length == 0) {
                        $(groupNumberClass+'.selected').click();                                    
                    } else {
                        eventQuantity.val(0).change();
                        eventQuantity.parent().show();
                        $('#btn-add-cart-package').show();
                    }

                    if (inGroup0){
                        $('html, body').scrollTop($('#group0').offset().top)
                    } else if (packageEvent.hasClass('group1')){
                        $('html, body').scrollTop($('#group1').offset().top)
                    }
                    
                    FG.Event['pickYourOwnDataArray'] = []
                });
                
                // This was done to prevent unselecting the parent item while in the middle of best available selection
                $('.PackageEvent.group0.selected').unbind('click.back').bind('click.back', function() {
                    packageGroupElement.html(currhtml);
                    $('.group1.selected').removeClass('selected').removeAttr('data-sectionselect').removeAttr('data-priceselect').removeAttr('data-seatids').removeAttr('data-tickettypes');
                    FG.Package.init();
                    $('.PackageEvent.group0.selected').unbind('click.back');
                });

                // Bind drop downs after load
                FG.Event.init(eventQuantity.val(), packageplanid);
                $('.group0.sel-qty').attr('disabled', true);
                
                packageGroupElement.stop().animate({'opacity': 1}, 500);

                if (!mobileJS) {
                    $('.custom-counter li:nth-child(2)').html('Click on <strong><u>up to ' + eventQuantity.val() + '</u></strong> ' + seatAltNamePlural);
                } else {
                    $('.custom-counter li:nth-child(2)').html('Pick <strong><u>up to ' + eventQuantity.val() + '</u></strong> ' + seatAltNamePlural);
                    $('.custom-counter li:nth-child(3)').html('Press the Select ' + seatAltNamePlural + ' button');
                    $('.custom-counter li:nth-child(1)').html('Touch a section');
                }
                

                // If best available within PYO.....
                // Not yet needed
                $('#btn-add-cart').unbind('click').bind('click', function (e) {
                    var priceSelect = $('#price-select option:selected').val();
                    var sectionSelect = $('#section-select option:selected').val();
                    var quantitySelect = $('#quantity option:selected').val();

                    var ticketTypes = FG.Event.getTicketTypes(sectionSelect,priceSelect);

                    pageElements.show();
                    $(groupNumberClass+'.sub-ribbon').show();
                    $(groupNumberClass+'.selectable-package-info').show();
                    packageGroupElement.html(currhtml);

                    e.preventDefault();
                    $('div.packageReserveInfo[data-packagegroupid="'+ packagegroupid +'"]').html(currhtml);

                    // Unbind before change events before init
                    $('.group0.sel-qty').unbind('change.bestavail').unbind('change.pickyourown');
                    
                    FG.Package.init();
                    eventQuantity.parent().show();

                    if (inGroup0){
                        if ($('.group1.single-item').length == 1){
                            $('.group1').show();
                        } else {
                            $('.group1').not('.group1.packageQuantity').show();
                        }
                        $('.group0.sel-qty').val(quantitySelect);      
                        $('html, body').scrollTop($('#group0').offset().top);
                        $('html, body').animate({scrollTop: $('#group1').offset().top}, 1000); 
                    } else {
                        $('.group0.sel-qty').val(group0qty);
                        $('select[data-packagegroupid="'+ packagegroupid +'"]').val(quantitySelect);
                        $('html, body').scrollTop($('#group1').offset().top);
                    }

                    $('div.PackageEvent.bestavail[data-eventhubkey="'+ eventhubkey +'"]').attr("data-priceselect", priceSelect);
                    $('div.PackageEvent.bestavail[data-eventhubkey="'+ eventhubkey +'"]').attr("data-sectionselect", sectionSelect);
                    $('div.PackageEvent.bestavail[data-eventhubkey="'+ eventhubkey +'"]').attr("data-ticketTypes", ticketTypes);

                    $('#btn-add-cart-package').show();

                    // Hide cart modal link to change seat, because no possible in packages right now.
                    FG.Event['pickYourOwnSelection'] = true;
                });


                // Unbind btn-add-cart-seat
                $('#btn-add-cart-seat').unbind('click').bind('click', function (e) {
                    

                    // check if there is are seats selected. if not, return out of the function
                    if (!FG.Event['pickYourOwnDataArray'] || FG.Event['pickYourOwnDataArray'].length == 0) {
                        return false
                    }

                    var seat_ids = [];
                    $(FG.Event['pickYourOwnDataArray']).each(function(){
                        seat_ids.push(this.seatId)
                    })
                    seat_count = seat_ids.length;
                    seat_ids = seat_ids.join();


                    var priceSelect = $('#price-select option:selected').val();
                    var sectionSelect = $('#section-select option:selected').val();
                    var quantitySelect = 1;

                    var ticketTypes = FG.Event.getTicketTypes(sectionSelect,priceSelect);
                    
                    
                    e.preventDefault();
        
                    pageElements.show();
                    $(groupNumberClass+'.sub-ribbon').show();
                    $(groupNumberClass+'.selectable-package-info').show();
                    packageGroupElement.html(currhtml);

                    // Unbind before change events before init
                    $('.group0.sel-qty').unbind('change.bestavail').unbind('change.pickyourown');
                    FG.Package.init();
                    eventQuantity.parent().show();


                    $('div.PackageEvent.pickyourown[data-eventhubkey="'+ eventhubkey +'"]').attr("data-bestavail", false);
                    $('div.PackageEvent.pickyourown[data-eventhubkey="'+ eventhubkey +'"]').attr("data-priceselect", priceSelect);
                    $('div.PackageEvent.pickyourown[data-eventhubkey="'+ eventhubkey +'"]').attr("data-sectionselect", sectionSelect);
                    $('div.PackageEvent.pickyourown[data-eventhubkey="'+ eventhubkey +'"]').attr("data-ticketTypes", ticketTypes);
                    $('div.PackageEvent.pickyourown[data-eventhubkey="'+ eventhubkey +'"]').attr("data-seatIds", seat_ids);
                    $('div.PackageEvent.pickyourown[data-eventhubkey="'+ eventhubkey +'"]').attr("data-seatCount", seat_count);


                    if (inGroup0){
                        if ($('.group1.single-item').length == 1){
                            $('.group1').show();
                        } else {
                            $('.group1').not('.group1.packageQuantity').show();
                        }
                        
                        $('.group0.sel-qty').val(seat_count);  
                        $('html, body').scrollTop($('#group0').offset().top);    
                        $('html, body').animate({scrollTop: $('#group1').offset().top}, 1000); 
                    } else {
                        $('.group0.sel-qty').val(group0qty);
                        $('select[data-packagegroupid="'+ packagegroupid +'"]').val(seat_count);
                        if ($('.group1.single-item').length == 1){
                            $('.group1.packageQuantity').show();
                        }
                        $('html, body').scrollTop($('#group1').offset().top);
                    }

                    $('#btn-add-cart-package').show();
                 
                    FG.Event['pickYourOwnDataArray'] = [];
                });
                
                $('.PackageEvent').unbind('click.revert').bind('click.revert', function(){
                    packageGroupElement.html(currhtml);
                    FG.Package.init();
                });
            });
        },

        /**
         * Bind best available buttons to pull in best available event partials
         */
        bindBestAvailable : function(packageEvent, eventQuantity) {
            var eventhubkey = packageEvent.data('eventhubkey');
            var packageplanid = packageEvent.data('packageplanid');
            var bestavailurl = document.location.protocol+"//"+document.location.host+"/event/" + eventhubkey + "/bestavailable?packageId=" + packageplanid;
            var inGroup0 = packageEvent.hasClass('group0');
            var group0qty = $('.group0.sel-qty').val();
            var packagegroupid = packageEvent.data('packageplangroupid');
            var packageGroupElement = $('div.packageReserveInfo[data-packagegroupid="'+ packagegroupid +'"]');
            var packageGroupElementHeight = packageGroupElement.css( "height" );
            var currhtml = packageGroupElement.html();
            var attr = packageEvent.attr('data-priceselect');
            var matchQuantity = $('select.matchQuantity[data-packagegroupid="'+ packagegroupid +'"]').length;
            var maxAmount = packageEvent.data('amountavailable');
            var groupNumber = packageEvent.attr('class').split(' ')[0]
            var groupNumberClass = "." + groupNumber
            var pageElements = $('.selectable-package').children().not("#"+groupNumber).not('.extraInfo');

            if (matchQuantity) {
                maxAmount = Math.min(parseInt($('select.group0').val()), maxAmount);
            }

            $.get(bestavailurl, function(html) {

                eventQuantity.parent().hide();
                $('#btn-add-cart-package').hide();
                packageGroupElement.html(html);

                $('#btn-add-cart').text('Select Options').removeClass('col-sm-8').addClass('col-sm-5 nopadding');
                var klon = $('#btn-add-cart');
                klon.clone().attr('id', 'btn-package-back' ).insertAfter( klon ).text('Cancel').removeClass('buynotready').addClass('btn-buy col-sm-offset-1');
                
                $('#quantity').unbind('change.disable').bind('change.disable', function(){
                    if ($('#quantity').val() > 0) { 
                        $('#btn-add-cart').removeClass('buynotready').addClass('btn-buy').attr("disabled", false);
                    } else {
                        $('#btn-add-cart').removeClass('btn-buy').addClass('buynotready').attr("disabled", true);
                    } 
                    
                })

                $('#quantity option:gt('+ maxAmount +')').remove();
                $('#quantity').val(eventQuantity.val()).change();

                //hide PYO/BA after it's been loaded
                $(groupNumberClass+'.sub-ribbon').hide();
                $(groupNumberClass+'.selectable-package-info').hide();
                $(pageElements).hide();

                $('#btn-package-back').unbind('click').bind('click', function(e) {
                     // Reset html back to previous state
                    pageElements.show();
                    $(groupNumberClass+'.sub-ribbon').show();
                    $(groupNumberClass+'.selectable-package-info').show();
                    
                    packageGroupElement.html(currhtml);
                    FG.Package.init();

                    if ($(groupNumberClass+'.single-item').length == 0) {
                        $(groupNumberClass+'.selected').click();                                    
                    } else {
                        eventQuantity.val(0).change();
                        eventQuantity.parent().show();
                    } 

                    if (inGroup0){
                        $('html, body').scrollTop($('#group0').offset().top)
                    } else if (packageEvent.hasClass('group1')){
                        $('html, body').scrollTop($('#group1').offset().top)
                    }   
                       
                });
                
                // This was done to prevent unselecting the parent item while in the middle of best available selection
                $('.PackageEvent.group0.selected').unbind('click.back').bind('click.back', function() {
                    packageGroupElement.html(currhtml);
                    FG.Package.init();
                    $('.PackageEvent.group0.selected').unbind('click.back');
                });

                // Bind drop downs after load
                FG.Event.init(maxAmount, packageplanid);
                $('.group0.sel-qty').attr('disabled', true);
                
                packageGroupElement.stop().animate({"opacity": 1}, 500);

                // Unbind btn-add-cart
                $('#btn-add-cart').unbind('click').bind('click', function (e) {
                    var priceSelect = $("#price-select option:selected").val();
                    var sectionSelect = $("#section-select option:selected").val();
                    var quantitySelect = $("#quantity option:selected").val();

                    var ticketTypes = FG.Event.getTicketTypes(sectionSelect,priceSelect);
                    
                    e.preventDefault();
                    
                    if (packageEvent.hasClass('buynotready')) {
                        return false;
                    }
                    pageElements.show();
                    $(groupNumberClass+'.sub-ribbon').show();
                    $(groupNumberClass+'.selectable-package-info').show();

                    packageGroupElement.html(currhtml);

                    // Unbind before change events before init
                    $('.group0.sel-qty').unbind('change.bestavail').unbind('change.pickyourown');
                    
                    FG.Package.init();
                    eventQuantity.parent().show();
                    $('#btn-add-cart-package').show();

                    $('div.PackageEvent.bestavail[data-eventhubkey="'+ eventhubkey +'"]').attr("data-priceselect", priceSelect);
                    $('div.PackageEvent.bestavail[data-eventhubkey="'+ eventhubkey +'"]').attr("data-sectionselect", sectionSelect);
                    $('div.PackageEvent.bestavail[data-eventhubkey="'+ eventhubkey +'"]').attr("data-ticketTypes", ticketTypes);
                    
                    if (inGroup0) {
                        if ($('.group1.single-item').length == 1){
                            $('.group1').show();
                        } else {
                            $('.group1').not('.group1.packageQuantity').show();
                        }
                        $('html, body').scrollTop($('#group0').offset().top)
                        $('html, body').animate({scrollTop: $("#group1").offset().top}, 1000);
                        $('.group0.sel-qty').val(quantitySelect);
                    } else {
                        $('.group0.sel-qty').val(group0qty);
                        $('select[data-packagegroupid="'+ packagegroupid +'"]').val(quantitySelect);
                        $('html, body').scrollTop($('#group1').offset().top);
                    }
                });
                
                //clicking on previous section's package-item while in bestavail/PYO view restores view of current package items 
                $('.PackageEvent').unbind('click.revert').bind('click.revert', function(){
                    packageGroupElement.html(currhtml);
                    FG.Package.init();

                });
            });
        },

        processAddCartResponse : function(FGResponse, cartGTM) {

            var $addToCart = $('#modal-addcart'), $responseModal;

            // Check for job response
            if (FGResponse.isJob == true) {

                // Set the response on base.
                if (FG.Base.setJobResponse(FGResponse)) {

                    setTimeout(function() {

                        var Ajax = new FG.Ajax('job/check');

                        Ajax.setMessageDiv('#div-add-cart-message');

                        Ajax.setSuccessCallback(function(FGResponse){
                            FG.Event.processAddCartResponse(FGResponse, cartGTM);
                        });

                        Ajax.setFailureCallback(function(FGResponse) {

                            $(".heading-tickets").html('Could not add the requested item');

                            $(".circle-spinner").remove();

                            $("#div-add-cart-message").after('<div style="text-align:right; margin-top:20px;"><span id="div-btn-goto-cart"></span><button type="button" onclick="window.location.reload();" class="fbtn">Close</button></div>');

                            // If the cart has expired, they need to get
                            // redirected to the cart expired page
                            if (FGResponse.errorType == 'CartExpiredException') {

                                // Redirect them to the cart expired page
                                window.location.href = $('#labelRoot').val() + '/cart/cart_expired';
                            }

                            // If we have a CartException, and the user has some
                            // qty in the cart, we need to ensure that the timer
                            // starts, because they partially carted.
                            if (FGResponse.errorType == 'CartException' && typeof FGResponse.data != 'undefined' && parseInt(FGResponse.data.qty) > 0) {

                                // Ensure that a cart timer has all the data it
                                // needs, and turn it on.
                                FG.Event.activateCartTimer(FGResponse);

                                $("#div-btn-goto-cart").html('<a href="' + $('#labelRoot').val() + '/cart">View Cart</a>&nbsp;&nbsp;&nbsp;');
                            }

                        });

                        Ajax.send();

                    }, FGResponse.wait);
                }

                return true;

            } else { // If we have a cart response, or a captcha response,
                        // run the add cart logic

                // If we have a CartException, and the user has some qty in the
                // cart, we need to ensure that the timer starts, because they
                // partially carted.
                if (FGResponse.errorType == 'CartException' && typeof FGResponse.data != 'undefined' && typeof FGResponse.data.qty != 'undefined' && parseInt(FGResponse.data.qty) > 0) {

                    // Ensure that a cart timer has all the data it needs, and
                    // turn it on.
                    FG.Event.activateCartTimer(FGResponse);
                }

                if (typeof FGResponse.data != 'undefined' && FGResponse.data.type == 'cart' || FGResponse.data.type == 'captchaResponse') {

                    $addToCart.modal('hide');

                    //Scroll to top of window where modal appears
                    window.scrollTo(0,0)

                    // Show a modal for the add to cart success message
                    $responseModal = $('<div>').addClass('modal tmp-modal').html(FGResponse.data.modal).appendTo("body");

                    $responseModal.modal({
                        backdrop : 'static',
                        keyboard : false
                    }).modal('show');

                    // Ensure that a cart timer has all the data it needs, and
                    // turn it on.
                    FG.Event.activateCartTimer(FGResponse);

                    // Notify Tradable Bits that user added package to their cart
                    FG.tradableBits().saveTrackingKey(FGResponse.data.order_tracking_key);
                    FG.tradableBits().trackPackageAddToCart();

                    $('#div-btn-add-cart').removeAttr('disabled');

                    // User did not pass the captcha, run captcha logic!
                } else if (typeof FGResponse.data != 'undefined' && FGResponse.data.type == 'captcha') {

                    $addToCart.modal('hide');

                    $("#modal-captcha").modal({
                        show : true,
                        backdrop : 'static',
                        width : '368px',
                        height : '286px'
                    });

                    // Some other invalid response type was received that the
                    // client has not handled yet
                } else {
                    $('#div-btn-add-cart').removeAttr('disabled');
                }
            }
        },

    }

})();
